import MerchantDelegations from '../pages/MerchantDelegations.vue';

const merchantDelegationsRoutes = [{
        name: 'نمایندگی های من',
        path: 'merchant-delegations',
        component: MerchantDelegations,
    },
];

export default merchantDelegationsRoutes;